<div>
  <div class="error-display__icons">
    <img src="assets/imgs/toast/error.svg" alt="Warning Message Icon" />
    <ion-icon name="close" class="error-display__close" *ngIf="close" (click)="closeAlert()"></ion-icon>
  </div>
  <h4>{{ title }}</h4>
  <p *ngIf="error">{{ 'EMPLOYEE_PORTAL.' + error.code | translate }}</p>
</div>
